if(document.body.classList.contains('template-product')) {
  const toggleNotifi = document.getElementById('toggle-notifi')
  const productLogicContainer = document.getElementById('product-logic-container')

  toggleNotifi && toggleNotifi.addEventListener('click', () => {

    productLogicContainer && productLogicContainer.classList.add('notifi-opened')

    const notifiInput = document.getElementById('notifi-contact-info')
    notifiInput && notifiInput.focus()

  })

  const detailsOpener = document.getElementById('details-opener')
  const detailsCloser = document.getElementById('details-closer')

  const deliveryOpener = document.getElementById('delivery-opener')
  const deliveryCloser = document.getElementById('delivery-closer')

  const returnsOpener = document.getElementById('returns-opener')
  const returnsCloser = document.getElementById('returns-closer')

  const helpOpener = document.getElementById('help-opener')
  const helpCloser = document.getElementById('help-closer')

  const productOverlayCloser = document.getElementById('product-overlay-closer')

  if( detailsOpener && detailsCloser ) {

    detailsOpener.addEventListener('click', () => {
      document.body.classList.add('details-opened')
    })

    detailsCloser.addEventListener('click', () => {
      document.body.classList.remove('details-opened')
    })

  }

  if( deliveryOpener && deliveryCloser ) {

    deliveryOpener.addEventListener('click', () => {
      document.body.classList.add('delivery-opened')
    })

    deliveryCloser.addEventListener('click', () => {
      document.body.classList.remove('delivery-opened')
    })

  }

  if( returnsOpener && returnsCloser ) {

    returnsOpener.addEventListener('click', () => {
      document.body.classList.add('returns-opened')
    })

    returnsCloser.addEventListener('click', () => {
      document.body.classList.remove('returns-opened')
    })

  }

  if( helpOpener && helpCloser ) {

    helpOpener.addEventListener('click', () => {
      document.body.classList.add('help-opened')
    })

    helpCloser.addEventListener('click', () => {
      document.body.classList.remove('help-opened')
    })

  }

  productOverlayCloser && productOverlayCloser.addEventListener('click', () => {
    document.body.classList.remove('delivery-opened','returns-opened','details-opened','help-opened')
  })



  // mobile logic
  const toggleVariants = document.getElementById('toggle-variants')
  const additionalToggleVariants = document.getElementById('toggle-variants-variant')
  const closeVariants = document.getElementById('close-variants')

  const showVariants = () => {
    document.body.classList.add('show-variants')
    document.body.classList.remove('show-product-form')
    document.body.classList.remove('show-notifi')
  }

  additionalToggleVariants && additionalToggleVariants.addEventListener('click', showVariants)
  toggleVariants && toggleVariants.addEventListener('click', showVariants)

  closeVariants && closeVariants.addEventListener('click', (e) => {
    document.body.classList.remove('show-variants')
  })


  // videos

  const markToObserve = document.querySelector('.product-logic-container-mark')
  const stickyTarget = document.querySelector("#product-logic-container")

  if(markToObserve && stickyTarget) {
    const stickyHeight = stickyTarget.clientHeight
    const handleFixedState = (entries) => {
      entries.forEach(entry => {
        if(!entry.isIntersecting && entry.boundingClientRect.top > stickyHeight) {
          stickyTarget.classList.add('fixed-mobile')
        } else {
          stickyTarget.classList.remove('fixed-mobile')
        }
      });
    };

    let observer = new IntersectionObserver(handleFixedState, {rootMargin: `${-Math.abs(stickyHeight)}px`});
    observer.observe(markToObserve);
  }
}